import { Component, inject, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import * as moment from "moment";
import { BaseUrlConstantsService } from "../../../../../app/services/base-url-constants.service";
import { PowerTrainService } from "../../../../../app/services/powertrain.service";
import { ConvertDatetimePipe } from "../../../../../app/convert-datetime.pipe";
import { PiezeoDashboardService } from "../../../../../app/services/piezo-dashboard.service";
import * as CanvasJS from "../../../../../components/client/powertrain-healthbar/canvasjs.stock.min";

interface HealthData {
  name: string;
  value: number;
  status: string;
  timestamp: string;
  color: string;
}

@Component({
  selector: "app-piezo-healthbar",
  templateUrl: "./piezo-healthbar.component.html",
  styleUrl: "./piezo-healthbar.component.scss",
  standalone: true,
  imports: [CommonModule, NgxChartsModule],
})
export class PiezoHealthbar implements OnInit {
  powertrainHealthBarUrl = BaseUrlConstantsService.POWERTRAIN_HEALTH_BAR_API;

  @Input("asset_ids") asset_ids: string[] = [];
  @Input("mac_addresses") mac_addresses: string[] = [];
  @Input("client_id") client_id: string[] = [];

  chartData: HealthData[] = [];
  selectedBar: any = null;

  public stackvelocitychartLoader = false;
  public stackvelocitychartErr = "";

  colorScheme = {
    domain: ["#4CAF50", "#FF9800", "#F44336", "#9E9E9E"],
  };

  customColors: any[] = [];
  service = inject(PiezeoDashboardService);

  constructor() {}

  ngOnInit() {
    let subsystem_data = null;
    this.service.subsystem_data$.subscribe((data) => {
      console.log("Subsystem data updated in healthbar:", data);
      subsystem_data = data;
    });
    console.log(Object.keys(subsystem_data));
    this.parseAssetIds(subsystem_data.device_position);
    this.fetchMachineHealthbar();
  }

  parseAssetIds(sensors?: any) {
    sensors = JSON.parse(sensors);
    if (!sensors) return;
    this.asset_ids = [];
    sensors.forEach((sensor: any) => {
      this.asset_ids.push(sensor.asset_id);
    });
    console.log("m::" + this.asset_ids);
  }
  async fetchMachineHealthbar() {
    try {
      this.stackvelocitychartLoader = true;
      this.stackvelocitychartErr = "";

      await this.service
        .fetchHealthBar(localStorage.getItem('user_id'), this.asset_ids.join(","), 24)
        .then((result: any[]) => {
         if (!result.length) {
          console.log("GOING IN IF")
          this.stackvelocitychartErr = "No Data Available";
        } else {
          this.stackvelocitychartErr = "";
          let stackData = [];
          for (let i = 1; i < result.length; i++) {
            let testDateUtc = moment.utc(result[i].bucket_date).toDate();
            let timeUpdatedAt = new ConvertDatetimePipe().convertDateTime(
              testDateUtc
            );

            let dateandtime = timeUpdatedAt.split(" ");
            let date = dateandtime[0].toString();
            let time = dateandtime[1].toString();
            stackData.push({
              type: "stackedBar",
              indexLabelFontColor: "red",
              xValueFormatString: time,

              color: result[i].highest_val == 0 ? "gray" : result[i].color,
              dataPoints: [{ x: 0, y: 30 }],
            });
          }
          const chart11 = new CanvasJS.Chart("stackvelocitychartContainer", {
            axisX: {
              valueFormatString: " ",
              titleFontSize: 100,
              gridThickness: 0,
              lineThickness: 0,
              tickThickness: 0,
            },
            axisY: {
              titleFontSize: 135,
              valueFormatString: " ",
              gridThickness: 0,
              lineThickness: 0,
              tickThickness: 0,
            },
            toolTip: {
              content: "{x}",
              shared: false,
            },
            dataPointWidth: 65,

            data: stackData,
            afterRender: function () {
              this.stackvelocitychartLoader = false;
            },
          });
          chart11.render();
        }
        })
        .catch((err) => {
          console.log(err);
          this.stackvelocitychartErr = "No Data Available";
          this.chartData = [];
        })
        .finally(() => {
          this.stackvelocitychartLoader = false;
        });
    } catch (error) {
      console.log(error);
    }
  }

  getStatusFromColor(hex: string): string {
    if (!hex) return "Unknown";

    const color = hex.toLowerCase();

    if (color === "#72ff13") return "Healthy"; // Green
    if (color === "#ffff00") return "Warning"; // Yellow
    if (color === "#ff0000") return "Critical"; // Red

    return "Unknown";
  }

  onSelect(event: any) {
    const selected = this.chartData.find((d) => d.name === event.name);
    if (selected) {
      this.selectedBar = {
        status: selected.status,
        timestamp: selected.timestamp,
        value: "N/A",
        count: 0,
        metrics: "N/A",
      };
    }
  }
}
